import { SITTER_DETAILS_FOR_PARENT_QUERY } from '@/graphql/messages/queries';
import { getSharedApolloClient } from '@/lib/apollo_setup';

const sitterDetailsForParent = async (accountId: string) => {
  const apolloClient = getSharedApolloClient();

  const res = await apolloClient.query({
    query: SITTER_DETAILS_FOR_PARENT_QUERY,
    variables: { accountId },
  });

  return res.data.account;
};

export default sitterDetailsForParent;
